<template>
  <v-main>
    <v-container fluid>
      <v-row class="mb-3" dense>
        <v-col cols="12">
          <v-card :class="reportType">
            <v-card-title primary-title class="white--text">
              <div>
                <h3 class="headline mb-2">
                  {{ reportHeader }}
                </h3>
                <h4 v-if="!isRoot">
                  {{ fullDateFormat(date) }}
                  {{ activePlace }}
                </h4>
              </div>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
      <router-view :report-info="reportInfo" />
    </v-container>
  </v-main>
</template>

<script>
import {mapState} from 'vuex'
// import CommonModals from './CommonModals'

export default {
  name: "ReportBase",
  // components: {CommonModals},
  data () {
    return {
    }
  },
  computed: {
    reportInfo () {
      let reportInfo =  Object.assign({}, this.$store.state.newOutreachReports)
      let users = reportInfo.users.some(v => typeof v === 'object' && v !== null) ? reportInfo['users'].map(v => v.id) :reportInfo['users']
      reportInfo['project'] = this.$store.state.tableData.projects.filter(v => v.id === reportInfo.project)[0]
      reportInfo['users'] = this.$store.state.tableData.users.filter(v => users.indexOf(v.id)>-1).map(u => u.name)
      reportInfo['place'] = this.$store.state.tableData.places.filter(v => v.id === reportInfo.place)[0]
      return reportInfo
    },

    reportHeader () {
      let text = 'Отчет'
      switch (this.reportType) {
        case "outreach":
          text = 'Отчет Аутрич сотрудника'
          break
        case "seminars":
          text = 'Отчет Семинаров'
          break
        case "casemanagement":
          text = 'Отчет КМ'
          break
        case "psych":
          text = 'Отчет Психолога'
          break
        case "lawyers":
          text = 'Отчет Юриста'
          break
        case "lgbtqcommunities":
          text = 'Отчет ЛГБТИК+'
          break
        default:
          text = 'Отчет Аутрич сотрудника'
      }
      return text
    },
    reportType () {
      return this.$route.meta.reportType
    },
    isRoot () {
      return this.$route.name === 'ReportOutreachNew'
    },
    activePlace (){
      const activePlace = this.places.find(place => place.id === this.place)
      return activePlace ? activePlace.name : null
    },
    ...mapState({
      places: state => state.tableData.places,
      users: state => state.tableData.users,
      productsList: state => state.tableData.products,
      testsList: state => state.tableData.tests,
      date: state => state.newOutreachReports.date,
      place: state => state.newOutreachReports.place,
    })
  },
}
</script>

<style lang="scss" scoped>
.loading-dialog {
  background-color: #303030
}

.outreach-header {
  background-color: #1976d2 !important;
  opacity: 0.8;
  padding: 10px
}

.case-header {
  background-color: #ffc107 !important;
  opacity: 0.8;
  padding: 10px
}

.read-only-header {
  background-color: gray !important;
  opacity: 0.8;
  padding: 10px
}
</style>



// WEBPACK FOOTER //
// src/components/reports/new/ReportBase.vue